var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("div", { staticClass: "loader" }, [
    _c("svg", { staticClass: "circular", attrs: { viewBox: "25 25 50 50" } }, [
      _c("circle", {
        staticClass: "path",
        attrs: {
          cx: "50",
          cy: "50",
          r: "20",
          fill: "none",
          "stroke-width": "2",
          "stroke-miterlimit": "10"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d738804", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d738804","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/Spinner.vue
// module id = 204
// module chunks = 17